import Webapi from './webapi'
import auth from '../auth'

export const chronoGraph = () =>
    new Webapi(false)
        .authorization(auth.get())
        .path('chrono-graph')
        .get()
